export function jfCliView() {

    return {
        restrict: 'E',
        scope: {
            snippet: '='
        },
        template: require('./jf_cli_view.html'),
        controller: jfCliViewController,
        controllerAs: 'jfCliView',
        bindToController: true
    }
}
class jfCliViewController {

    constructor() {
    }

}



// WEBPACK FOOTER //
// ./modules/xray/directives/jf_cli_view/jf_cli_view.js